import { defaultFetch } from "./baseApi";
export type NoticeType = {
    id: number;
    call: string;
    fund: {
        code: string;
    };
    streamConfigurationType: string;
};

export const getNotices = () => {
    return defaultFetch<NoticeType[]>('/v0/notices');
}